<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="d-grid grid-prospect gap-32">
        @if(isLoading) {
        <div class="loading-spinner"></div>
        } @else if (errorMessage) {
        <div class="error-message">{{errorMessage}}</div>
        } @else if (account) {
        <div>
          <div class="prospect-card">
            <div class="d-grid prospect-title mt-3">
              <div><h4 class="color-gray t-20">Cuentas</h4></div>
              <div class="d-grid card-buttons-3 align-self-end">
                <button
                  class="btn btn-primary-outline"
                  (click)="openMdlDeleteAccount()"
                >
                  Eliminar
                </button>
                <button
                  class="btn btn-primary"
                  (click)="openManageAccount(account)"
                >
                  Modificar
                </button>
              </div>
            </div>

            <div>
              <div class="d-grid prospect-name">
                <div><img src="assets/svg/account.svg" alt="" /></div>
                <div>
                  <h2 class="text-semibold">{{account.nombre_empresa}}</h2>
                </div>
              </div>
              <div class="d-flex flex-row gap-20 justify-center">
                <div class="text-tag color-org text-center">
                  <b>&Uacute;ltima actualizaci&oacute;n:</b>
                  {{account.fecha_actualizacion | date: 'dd/MM/yyyy'}}
                </div>
              </div>
              <div class="d-grid card-buttons-2">
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openNewCall()">
                    <img class="center-svg" src="assets/svg/call-icon.svg" />
                  </button>
                  <h5>Llamada</h5>
                </div>
                <div class="text-center event-item">
                  <button class="btn btn-round-outline" (click)="openNewTask()">
                    <img class="center-svg" src="assets/svg/task-icon.svg" />
                  </button>
                  <h5>Tarea</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openNewEvent()"
                  >
                    <img class="center-svg" src="assets/svg/event-icon.svg" />
                  </button>
                  <h5>Evento</h5>
                </div>
                <div class="text-center event-item">
                  <button
                    class="btn btn-round-outline"
                    (click)="openSendMail()"
                  >
                    <img class="center-svg" src="assets/svg/mail-icon.svg" />
                  </button>
                  <h5>Correo</h5>
                </div>
              </div>

              <div class="info-card">
                <div class="d-grid info-card-title">
                  <h3>Informaci&oacute;n de la cuenta</h3>
                  <div class="d-grid card-buttons-1">
                    <div *ngIf="!editInfo">
                      <img
                        src="assets/svg/edit.svg"
                        alt="Editar"
                        class="icon-clickable"
                        (click)="toggleEdit('info')"
                      />
                    </div>

                    <div *ngIf="editInfo" class="d-flex gap-10">
                      <button
                        class="btn btn-primary"
                        (click)="saveSection('info')"
                      >
                        Guardar
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="cancelEdit('info')"
                      >
                        Cancelar
                      </button>
                    </div>
                    <div class="d-grid">
                      <button
                        class="btn btn-round-outline-mini"
                        (click)="toggleSection('info')"
                      >
                        <img
                          class="center-svg arrow-toggle"
                          [class.rotated]="!showInfoSection"
                          src="assets/svg/arrow-up.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail">
                  <table class="info-table" *ngIf="showInfoSection">
                    <tbody>
                      <tr>
                        <td>Nombre de la cuenta:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editNombre">
                            {{ account.nombre_empresa }}
                          </ng-container>
                          <ng-template #editNombre>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableAccount.nombre_empresa"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Rut:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editRut">
                            {{ account.rut || '-' }}
                          </ng-container>
                          <ng-template #editRut>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableAccount.rut"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Teléfono:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editTel">
                            {{ account.telefono || '-' }}
                          </ng-container>
                          <ng-template #editTel>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableAccount.telefono"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Divisa de la cuenta:</td>
                        <td>
                          <ng-container *ngIf="!editInfo; else editDivisa">
                            {{ account.divisa_cuenta || 'CLP' }}
                          </ng-container>
                          <ng-template #editDivisa>
                            <select
                              class="crm-input"
                              [(ngModel)]="editableAccount.divisa_cuenta"
                            >
                              <option value="CLP">CLP</option>
                              <option value="USD">USD</option>
                              <option value="EUR">EUR</option>
                            </select>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Propietario:</td>
                        <td>
                          {{ account.propietario?.nombre || '-' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Detalles de la cuenta</h3>
                  <div class="d-grid card-buttons-1">
                    <div *ngIf="!editDetails">
                      <img
                        src="assets/svg/edit.svg"
                        alt="Editar"
                        class="icon-clickable"
                        (click)="toggleEdit('details')"
                      />
                    </div>

                    <div *ngIf="editDetails" class="d-flex gap-10">
                      <button
                        class="btn btn-primary"
                        (click)="saveSection('details')"
                      >
                        Guardar
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="cancelEdit('details')"
                      >
                        Cancelar
                      </button>
                    </div>
                    <div class="d-grid">
                      <button
                        class="btn btn-round-outline-mini"
                        (click)="toggleSection('details')"
                      >
                        <img
                          class="center-svg arrow-toggle"
                          [class.rotated]="!showDetailsSection"
                          src="assets/svg/arrow-up.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail">
                  <table class="info-table" *ngIf="showDetailsSection">
                    <tbody>
                      <tr>
                        <td>Sitio Web:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editSitio">
                            {{ account.sitio_web || '-' }}
                          </ng-container>
                          <ng-template #editSitio>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableAccount.sitio_web"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Industria:</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editIndustria"
                          >
                            {{ account.industria?.nombre || '-' }}
                          </ng-container>
                          <ng-template #editIndustria>
                            <select
                              class="crm-input"
                              [(ngModel)]="editableAccount.industria_id"
                            >
                              <option
                                *ngFor="let ind of industrias"
                                [value]="ind.industria_id"
                              >
                                {{ ind.nombre }}
                              </option>
                            </select>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Subfamilia:</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editSubfamilia"
                          >
                            {{ account.subfamilia || '-' }}
                          </ng-container>
                          <ng-template #editSubfamilia>
                            <select
                              class="crm-input"
                              [(ngModel)]="editableAccount.subfamilia"
                            >
                              <option value="" disabled>
                                Seleccionar tipo de subfamilia
                              </option>
                              <option value="A">A</option>
                              <option value="B">B</option>
                            </select>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Teléfono:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editTelefono">
                            {{ account.telefono || '-' }}
                          </ng-container>
                          <ng-template #editTelefono>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableAccount.telefono"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>LinkedIn empresa:</td>
                        <td>
                          <ng-container *ngIf="!editDetails; else editLinkedin">
                            {{ account.linkedin || '-' }}
                          </ng-container>
                          <ng-template #editLinkedin>
                            <input
                              class="crm-input"
                              type="text"
                              [(ngModel)]="editableAccount.linkedin"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Cantidad empleados:</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editEmpleados"
                          >
                            {{ account.empleados || '-' }}
                          </ng-container>
                          <ng-template #editEmpleados>
                            <input
                              class="crm-input"
                              type="number"
                              [(ngModel)]="editableAccount.empleados"
                            />
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Descripción:</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editDescripcion"
                          >
                            {{ account.descripcion || '-' }}
                          </ng-container>
                          <ng-template #editDescripcion>
                            <textarea
                              class="crm-input"
                              rows="3"
                              [(ngModel)]="editableAccount.descripcion"
                            ></textarea>
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td>Dirección:</td>
                        <td>
                          <ng-container
                            *ngIf="!editDetails; else editDireccion"
                          >
                            {{ account.calle_fact || '-' }}
                          </ng-container>
                          <ng-template #editDireccion>
                            <textarea
                              class="crm-input"
                              rows="3"
                              [(ngModel)]="editableAccount.calle_fact"
                            ></textarea>
                          </ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="info-card mt-4">
                <div class="d-grid info-card-title">
                  <h3>Historial registro</h3>
                  <div class="d-grid card-buttons-1">
                    <div class="d-grid">
                      <button
                        class="btn btn-round-outline-mini"
                        (click)="toggleSection('history')"
                      >
                        <img
                          class="center-svg arrow-toggle"
                          [class.rotated]="!showHistorySection"
                          src="assets/svg/arrow-up.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="info-card-detail">
                  <table class="info-table" *ngIf="showHistorySection">
                    <tbody>
                      <tr>
                        <td>Creado por:</td>
                        <td>
                          <div
                            class="d-flex flex-row align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" />
                            <u>{{account.creado_por?.nombre || 'Sistema'}}</u>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-row align-items-center">
                            {{account.fecha_creacion | date: 'dd-MM-yyyy
                            HH:mm'}}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Modificado por:</td>
                        <td>
                          <div
                            class="d-flex flex-row align-items-center color-org"
                          >
                            <img src="assets/svg/avatar.svg" alt="" />
                            <u
                              >{{account.actualizado_por?.nombre ||
                              'Sistema'}}</u
                            >
                          </div>
                        </td>
                        <td>
                          <div class="d-flex flex-row align-items-center">
                            {{account.fecha_actualizacion | date: 'dd-MM-yyyy
                            HH:mm'}}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        <div class="detail-container white-bg">
          <app-nav-account [account]="account"></app-nav-account>
        </div>
      </div>
    </div>
  </div>
</div>
